/**
 * Frequently Asked Questions
 * --------------------------
 */

if($('.frequently-asked-questions').length) {

    let groupLabels = $('.faq-group-label'),
        questionAnswerGroups = $('.faq-group-questions-answers'),
        questionLabels = $('.question-item'),
        answerItems = $('.answer-item'),
        firstOpenTriggered = false;

    setTimeout(function () {
        groupLabels.first().click();
    }, 300);

    groupLabels.on('click', function () {

        let group = $(this).parent().find('.faq-group-questions-answers'),
            container = $(this).parent();

        if($(this).hasClass('active')) {

            $(this).removeClass('active');
            group.slideUp();

        } else {

            groupLabels.not($(this)).removeClass('active');
            $(this).addClass('active');

            questionAnswerGroups.not(group).slideUp();

            group.slideDown();
            setTimeout(function () {
                group.find('.question-item').first().click();
            }, 200);

            if(firstOpenTriggered) {
                setTimeout(function () {
                    $('html, body').animate({ scrollTop: (container.offset().top - $('#site-header').outerHeight()) }, 500);
                }, 400);
            } else {
                firstOpenTriggered = true;
            }

        }

    });

    questionLabels.on('click', function () {

        let answer = $(this).parent().find('.answer-item');

        if($(this).hasClass('active')) {

            $(this).removeClass('active');
            answer.slideUp();

        } else {

            questionLabels.not($(this)).removeClass('active');
            $(this).addClass('active');

            answerItems.not($(this)).slideUp();

            answer.slideDown();

        }

    });

}